"use client"

import { useState } from "react"
import { useTranslation } from "react-i18next"

export default function LoginDialog() {
  const {t} = useTranslation("common")
  const [showPopup, setShowPopup] = useState(false)
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [message, setMessage] = useState("")

  function handleLogin() {
    if (username === "admin" && password === "admin") {
      setMessage("The cake is a lie")
    } else {
      setMessage("Wrong username or password")
    }
  }

  return (
    <div className="relative inline-block">
      <button
        className="rounded-md border px-4 py-2 text-sm font-medium hover:bg-gray-300 transition border-black text-black override"
        onClick={() => setShowPopup(!showPopup)}
      >
        {t("navigation.login")}
      </button>

      {showPopup && (
        <div className="absolute top-full mt-2 right-0 w-64 p-4 bg-white border border-gray-300 rounded-md shadow-lg z-10">
          <div className="space-y-3">
            <div className="flex flex-col">
              <p className="text-black override">{t("login.username")}</p>
              <input
                type="text"
                className="border px-2 py-1 rounded-md mt-1 text-sm text-black override"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="flex flex-col">
              <p className="text-black override">{t("login.password")}</p>
              <input
                type="password"
                className="border px-2 py-1 rounded-md mt-1 text-sm text-black override"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button
              className="w-full bg-black text-white py-1 rounded-md hover:bg-gray-800 transition text-sm"
              onClick={handleLogin}
            >
              {t("login.button")}
            </button>

            {message && (
              <p className="text-center text-sm mt-1 text-black override">{message}</p>
            )}
          </div>
        </div>
      )}
    </div>
  )
}